<template>
  <div>
    <Banner bgsrc="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/contact/contact_banner.png">
      <span class="w-banner_text" style="color: #ffffff;">{{ this.$t('connection.contactUs') }}</span>
    </Banner>
    <div class="w-connection_contactUs">
      <div>
        <XYTitle xText="CONTACT US"></XYTitle>
      </div>
      <div class="w-contactUs_title">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-title-text1">
            <i class="iconfont icon-contact_icon_telephone"></i>
            <span>400-626-5529</span>
          </div>
        </Animation>
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-title-text2">
            <span class="w-subsidiary_text">TELEPHONE</span>
          </div>
        </Animation>
      </div>
      <div class="w-contactUs_content">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-content_text">
            <div class="w-bigTitle_text">{{ this.$t('about.XY') }}</div>
            <div class="w-subsidiary_text">XUYU TECHNOLOGY</div>
            <div class="w-text_item">
              <span class="w-nonParagraph_text w-item_title">{{ this.$t('connection.contactUsItemTitle1') }}</span>
              <span class="w-nonParagraph_text w-item_text">{{ this.$t('connection.contactUsItemText1') }}</span>
            </div>
            <div class="w-text_item">
              <span class="w-nonParagraph_text w-item_title">{{ this.$t('connection.contactUsItemTitle2') }}</span>
              <span class="w-nonParagraph_text w-item_text">{{ this.$t('connection.contactUsItemText2') }}</span>
            </div>
            <div class="w-text_item">
              <span class="w-nonParagraph_text w-item_title">{{ this.$t('connection.contactUsItemTitle3') }}</span>
              <span class="w-nonParagraph_text w-item_text">{{ this.$t('connection.contactUsItemText3') }}</span>
            </div>
            <div class="w-text_item">
              <span class="w-nonParagraph_text w-item_title">{{ this.$t('connection.contactUsItemTitle4') }}</span>
              <span class="w-nonParagraph_text w-item_text">{{ this.$t('connection.contactUsItemText4') }}</span>
            </div>
          </div>
        </Animation>
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-content_img">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/contact/contact_img.png" alt="#">
          </div>
        </Animation>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from '@/components/Banner'
import XYTitle from '@/components/XYTitle'
import Animation from '@/components/Animation'
import Footer from '@/components/Footer.vue'
export default {
  props: {

  },
  data () {
    return {

    };
  },
  methods: {

  },
  components: {
    Banner, XYTitle, Animation,Footer
  },
};
</script>

<style scoped lang="scss">

</style>
